import it from '../static/i18n/it_IT';
import en from '../static/i18n/en_US';
import { config } from './config';

const labels = config.LANG === 'it' ? it : en;
const notTranslated: string[] = [];
function getNotTranslated() {
	return notTranslated.map((id) => `'${id}': ''`).join(',\n');
}

if (typeof window !== 'undefined') {
	// the variable is defined
	(window as any).getNotTranslated = getNotTranslated;
}

export function t(...stringIds: ReadonlyArray<string | TemplateStringsArray>) {
	let i = 0;
	for (i; i < stringIds.length; i++) {
		const stringId = stringIds[i];

		if (!stringId) continue;

		const id = typeof stringId === 'string' ? stringId : stringId[0];

		if (id in labels) return labels[id];

		// console.warn(`String "${id}" not translated!`);
		if (notTranslated.indexOf(id) === -1) {
			notTranslated.push(id);
		}
		if (i === stringIds.length - 1) return id;
	}
}

export default t;
